var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP4A = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 349.996,
  height: 333.331,
  viewBox: "0 0 349.996 333.331"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P4A_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.998h262.497V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .012 333.33h349.984V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P4A_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.33)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m189.323 62.6 11.428 40.364h.23L211.458 62.6zm20.112 53.488h-16.66l-27.852-86.42h15.237l5.95 20.8h28.568l5.832-20.8h15.71zM132.97 60.415h-21.177l20.935 37.41h.24zm16.212 55.434H128.13L96.552 61.525V47.574h36.417V29.668h16.21v17.906h10.773v12.84H149.18zm-67.66 41.32h-9.65v41.956h9.65c14.182 0 26.192-5.512 26.192-21.47 0-15.954-12.412-20.488-26.192-20.488m54.953 22.062c0 32.9-27.38 41.568-57.32 41.568h-34.87V83.303h27.588v52.194h11.613c29.548 0 52.99 11.626 52.99 43.735"
}))));
export default SvgParkingP4A;